import React from 'react';
import { 
  FaMapMarkerAlt, 
  FaPhoneAlt, 
  FaEnvelope, 
  FaClock,
  FaFacebook,
  FaInstagram,
  FaTwitter,
  FaYoutube,
  FaArrowRight,
  FaMotorcycle,
  FaCar,
  FaWrench,
  FaShieldAlt,
} from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'Home', href: '/' },
    { name: 'About Us', href: 'about' },
    { name: 'Services', href: 'services' },
    { name: 'Contact', href: 'contact' }
  ];

  const services = [
    { name: 'Bike Servicing', href: 'services' },
    { name: 'Car Servicing', href: 'services' },
    { name: 'Engine Repair', href: 'services' },
    { name: 'Battery Service', href: 'services' }
  ];

  return (
    <footer className="bg-gray-900 text-white">
      {/* Main Footer */}
      <div className="container mx-auto px-4 md:px-8 max-w-7xl py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          
          {/* Column 1 - Logo and About */}
          <div>
            {/* Logo */}
            <div className="flex items-center gap-3 mb-4">
              <div className="w-14 h-10  flex items-center justify-center">
                <FaWrench className="text-white text-xl" />
                   <img
                    src="/logo.png"
                    alt="Ambris Logo"
                    className="w-14 h-12 md:w-12 md:h-12 object-contain"
                  />
              </div>
              <div>
                <h2 className="text-xl font-bold text-white">Ambris<span className="text-red-500">Service</span></h2>
                <p className="text-gray-400 text-xs">Bike & Car Service Center</p>
              </div>
            </div>
            
            <p className="text-gray-400 text-sm leading-relaxed mb-4">
              Trusted vehicle service provider in Varanasi. We provide reliable, affordable, and high-quality servicing solutions for both bikes and cars.
            </p>
            
            {/* Social Icons */}
            <div className="flex gap-3">
              <a href="#" className="w-8 h-8 bg-gray-800 hover:bg-red-600 rounded-full flex items-center justify-center transition-colors duration-300">
                <FaFacebook className="text-gray-400 hover:text-white text-sm" />
              </a>
              <a href="#" className="w-8 h-8 bg-gray-800 hover:bg-red-600 rounded-full flex items-center justify-center transition-colors duration-300">
                <FaInstagram className="text-gray-400 hover:text-white text-sm" />
              </a>
              <a href="#" className="w-8 h-8 bg-gray-800 hover:bg-red-600 rounded-full flex items-center justify-center transition-colors duration-300">
                <FaTwitter className="text-gray-400 hover:text-white text-sm" />
              </a>
              <a href="#" className="w-8 h-8 bg-gray-800 hover:bg-red-600 rounded-full flex items-center justify-center transition-colors duration-300">
                <FaYoutube className="text-gray-400 hover:text-white text-sm" />
              </a>
            </div>
          </div>

          {/* Column 2 - Quick Links */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-4 relative inline-block">
              Quick Links
              <span className="absolute bottom-0 left-0 w-12 h-0.5 bg-red-500 mt-1"></span>
            </h3>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <a href={link.href} className="text-gray-400 hover:text-red-500 text-sm transition-colors duration-300 flex items-center gap-2 group">
                    <FaArrowRight className="text-xs opacity-0 group-hover:opacity-100 transition-opacity" />
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3 - Our Services */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-4 relative inline-block">
              Our Services
              <span className="absolute bottom-0 left-0 w-12 h-0.5 bg-red-500 mt-1"></span>
            </h3>
            <ul className="space-y-2">
              {services.map((service) => (
                <li key={service.name}>
                  <a href={service.href} className="text-gray-400 hover:text-red-500 text-sm transition-colors duration-300 flex items-center gap-2 group">
                    <FaArrowRight className="text-xs opacity-0 group-hover:opacity-100 transition-opacity" />
                    {service.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 4 - Contact Info */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-4 relative inline-block">
              Contact Info
              <span className="absolute bottom-0 left-0 w-12 h-0.5 bg-red-500 mt-1"></span>
            </h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <FaMapMarkerAlt className="text-red-500 text-lg mt-0.5" />
                <span className="text-gray-400 text-sm">Sathawa, Sarnath, Varanasi, Uttar Pradesh - 221007</span>
              </li>
              <li className="flex items-center gap-3">
                <FaPhoneAlt className="text-red-500 text-sm" />
                <a href="tel:+911234567890" className="text-gray-400 hover:text-red-500 text-sm transition-colors">+91 8081321406</a>
              </li>
              <li className="flex items-center gap-3">
                <FaEnvelope className="text-red-500 text-sm" />
                <a href="mailto:info@ambrisservice.com" className="text-gray-400 hover:text-red-500 text-sm transition-colors">info@ambrisservice.com</a>
              </li>
              <li className="flex items-start gap-3">
                <FaClock className="text-red-500 text-lg mt-0.5" />
                <span className="text-gray-400 text-sm">Mon-Sun: 8:00 AM - 8:00 PM<br />24/7 Emergency Support</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-800 my-8"></div>

        {/* Bottom Bar */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">
            &copy; {currentYear} Ambris Service Center. All rights reserved.
          </p>
          <div className="flex gap-6">
            <a href="privacypolicy" className="text-gray-500 hover:text-red-500 text-xs transition-colors">Privacy Policy</a>
            <a href="termsconditions" className="text-gray-500 hover:text-red-500 text-xs transition-colors">Terms & Conditions</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;